import React from "react";
import "./hero.scss";
import heroImg from "../../../assets/about/clinic/3.JPG";

const PPCHero = () => {
  return (
    <section id="home" className="ppc-hero">
      <div className="hero-container">
        <div className="hero-grid">
          {/* LEFT */}
          <div className="hero-left">
            <div className="eyebrow">
              <span className="dot" aria-hidden="true" />
              Premium dentistry • HSR Layout
            </div>

            <h1>Trusted Dental Clinic in HSR Layout</h1>

            <p className="lead">
              Creating beautiful smiles with precision-led care, advanced tech,
              and a comfort-first experience.
            </p>

            {/* Proof rail */}
            <div className="proof-rail" aria-label="Clinic trust indicators">
              <div className="proof">
                <span className="proof-label">Rated</span>
                <span className="proof-value">4.9/5</span>
              </div>
              <div className="divider" aria-hidden="true" />
              <div className="proof">
                <span className="proof-label">Smiles enhanced</span>
                <span className="proof-value">5,000+</span>
              </div>
              <div className="divider" aria-hidden="true" />
              <div className="proof">
                <span className="proof-label">Experience</span>
                <span className="proof-value">15+ yrs</span>
              </div>
            </div>

            {/* USPs */}
            <div className="usp-grid">
              <div className="usp">
                <span className="usp-icon" aria-hidden="true">🥇</span>
                <div className="usp-text">
                  <div className="usp-title">Top 1% Invisalign Provider</div>
                  <div className="usp-sub">Evidence-led treatment plans</div>
                </div>
              </div>

              <div className="usp">
                <span className="usp-icon" aria-hidden="true">😁</span>
                <div className="usp-text">
                  <div className="usp-title">Smile Transformations</div>
                  <div className="usp-sub">Ortho + cosmetic approach</div>
                </div>
              </div>

              <div className="usp">
                <span className="usp-icon" aria-hidden="true">🦷</span>
                <div className="usp-text">
                  <div className="usp-title">Advanced Implants</div>
                  <div className="usp-sub">Grafting & complex cases</div>
                </div>
              </div>

              <div className="usp">
                <span className="usp-icon" aria-hidden="true">🔬</span>
                <div className="usp-text">
                  <div className="usp-title">Microscope-Assisted RCTs</div>
                  <div className="usp-sub">Precision-focused outcomes</div>
                </div>
              </div>
            </div>

            {/* CTAs */}
            <div className="hero-actions">
              <a href="#contact" className="btn btn-primary">
                Book Appointment
              </a>
           
            </div>

            <div className="fineprint">
              Same-day consultations available (subject to slots).
            </div>
          </div>

          {/* RIGHT */}
          <div className="hero-right">
            <div className="image-frame">
              <img
                src={heroImg}
                alt="Best Dental Clinic in HSR Layout"
                width="820"
                height="620"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />

              {/* Floating trust card */}
              <div className="floating-card" role="note" aria-label="Quick trust card">
                <div className="fc-title">Award-winning care</div>
                <div className="fc-sub">
                  Premium materials • Sterile protocols • Gentle dentistry
                </div>
              </div>
            </div>

            {/* Decorative glow */}
            <div className="glow" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPCHero;
